import { Link } from "react-router-dom";
import type { Revendeur } from "../data/products";

type RevendeurCtaProps = {
  revendeurs: Revendeur[];
};

export default function RevendeurCta({ revendeurs }: RevendeurCtaProps) {
  return (
    <>
      {revendeurs.map((revendeur: Revendeur, index) => {
        const { name, url, prix } = revendeur;
        return (
          <Link to={url} key={index} className="btn">
            Acheter chez {name} pour{" "}
            <span style={{ fontWeight: "bolder" }}>{prix}€</span>
          </Link>
        );
      })}
    </>
  );
}
